<template lang="pug">
  div
    drawer-menu 
    page-nav-bar    
    v-main
      router-view
</template>
<script>
import DrawerMenu from '@/components/tec/core/DrawerMenu.vue'
import PageNavBar from '@/components/tec/core/PageNavBar.vue'
export default {
  mounted() {
    this.$router.push({path: '/technological/home'});
  },
  data() {
    return {
      items: [
        { title: 'Documentación', icon: 'mdi-view-dashboard', route: {name: 'docs'} },
        { title: 'APIs', icon: 'mdi-image', route: {name: 'apis'} },
        { title: 'Soporte NUFI', icon: 'mdi-help-box', route: {name: 'support'} },
      ],
      right: null,
    }
  },
  components: {  
    DrawerMenu,
    PageNavBar
  }
}
</script>